import type { PropsWithChildren } from 'react';

type InfoSectionSeparatorProps = PropsWithChildren;

export const InfoSectionSeparator = ( { children }: InfoSectionSeparatorProps ) => {

  return (
    <hr className={ 'border-[rgba(171,176,199,0.30)] my-4 last:hidden' }>
      { children }
    </hr>
  )
}
InfoSectionSeparator.displayName = 'InfoSectionSeparator';
